import { render, staticRenderFns } from "./MemberNavbar.vue?vue&type=template&id=b197e688&"
import script from "./MemberNavbar.vue?vue&type=script&lang=js&"
export * from "./MemberNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports